// ignore-string-externalization

import React from 'react';
import {
  Colors,
  ArticleHeaderModule as FrodorArticleHeaderModule,
} from '@spotify-internal/frodor-modules';
import { ContentfulAsset } from '../../Contentful';
import { useShareButtonsCopy } from '../../ui/copy';
import { useCurrentPageUrl } from '../utils';

type ArticleHeaderModuleType = {
  textColor?: string;
  backgroundColor?: string;
  headline?: string;
  supertext?: string;
  image: ContentfulAsset;
  authorDateString?: string;
  colors: Colors;
};

export const ArticleHeaderModule: React.FC<ArticleHeaderModuleType> = ({
  headline = '',
  supertext = '',
  colors,
  image,
  authorDateString = '',
}) => {
  const shareButtonsCopy = useShareButtonsCopy();
  const currentPageUrl = useCurrentPageUrl();

  return (
    <FrodorArticleHeaderModule
      headline={headline}
      supertext={supertext}
      image={image}
      authorDateString={authorDateString}
      copy={shareButtonsCopy}
      colors={colors}
      shareUrl={currentPageUrl}
    />
  );
};
